import {useEffect} from 'react'
import {useSelector} from 'react-redux'
import {Outlet, useLocation, useNavigate} from 'react-router-dom'
import {MenuComponent} from '../assets/ts/components'
import {InviteUsers, UpgradePlan} from '../partials'
import {AsideDefault} from './components/aside/AsideDefault'
import {Content} from './components/Content'
import {Footer} from './components/Footer'
import {HeaderWrapper} from './components/header/HeaderWrapper'
import {ScrollTop} from './components/ScrollTop'
import {PageDataProvider} from './core'

const MasterLayout = () => {
  const location = useLocation()
  const userInfo = useSelector((state: any) => state.userInfo)
  const navigator = useNavigate()
  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [])

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [location.key])

  useEffect(() => {
    if (!userInfo) {
      navigator('/auth')
    }
  }, [userInfo, navigator])
  if (!window.location.pathname.includes('charge')) {
    document.body.setAttribute('data-kt-aside-minimize', 'off')
  }

  const isChargePage = location.pathname.includes('charge')

  return (
    <PageDataProvider>
      <div className='page d-flex flex-row flex-column-fluid'>
        <AsideDefault />
        <div className='wrapper d-flex flex-column flex-row-fluid' id='kt_wrapper'>
          <HeaderWrapper />

          <div id='kt_content' className='content d-flex flex-column flex-column-fluid p-0'>
            <div className='post d-flex flex-column-fluid' id='kt_post'>
              <Content>
                <Outlet />
              </Content>
            </div>
          </div>
          {/* <Footer /> */}
          {!isChargePage && <Footer />}
        </div>
      </div>

      {/* begin:: Drawers */}
      {/*<DrawerMessenger />*/}
      {/* end:: Drawers */}

      {/* begin:: Modals */}
      <InviteUsers />
      <UpgradePlan />
      {/* end:: Modals */}
      <ScrollTop />
    </PageDataProvider>
  )
}

export {MasterLayout}
